import {Container} from '@mantine/core'
import {createFileRoute} from '@tanstack/react-router'

import {DashboardPage} from '../../dashboard/dashboard-page'

export const Route = createFileRoute('/_app/')({
    component: IndexPage,
})

function IndexPage() {
    return (
        <Container size="lg" py="xl">
            <DashboardPage />
        </Container>
    )
}
